// extracted by mini-css-extract-plugin
export default {"saveSentenceBtn":"WordBuilder_saveSentenceBtn__5gjtL","divider":"WordBuilder_divider__6Nw4v","marginTop":"WordBuilder_marginTop__pUt52"};